import { ErrorAPI } from '../interfaces';
import { InviteUserRequest, MerchantUsersResponse } from './interfaces';

export enum UserManagementActionType {
  GET_MERCHANT_USERS = 'USER_MANAGEMENT/GET_MERCHANT_USERS',
  GET_MERCHANT_USERS_SUCCESS = 'USER_MANAGEMENT/GET_MERCHANT_USERS_SUCCESS',
  GET_MERCHANT_USERS_ERROR = 'USER_MANAGEMENT/GET_MERCHANT_USERS_ERROR',
  DELETE_MERCHANT_USER = 'USER_MANAGEMENT/DELETE_MERCHANT_USER',
  DELETE_MERCHANT_USER_SUCCESS = 'USER_MANAGEMENT/DELETE_MERCHANT_USER_SUCCESS',
  DELETE_MERCHANT_USER_ERROR = 'USER_MANAGEMENT/DELETE_MERCHANT_USER_ERROR',
  SWAP_OWNER_ROLE = 'USER_MANAGEMENT/SWAP_OWNER_ROLE',
  SWAP_OWNER_ROLE_SUCCESS = 'USER_MANAGEMENT/SWAP_OWNER_ROLE_SUCCESS',
  SWAP_OWNER_ROLE_ERROR = 'USER_MANAGEMENT/SWAP_OWNER_ROLE_ERROR',
  UPDATE_USER_ROLE = 'USER_MANAGEMENT/UPDATE_USER_ROLE',
  CLEAN_ERROR = 'USER_MANAGEMENT/CLEAN_ERROR',
  INVITE_USER = 'USER_MANAGEMENT/INVITE_USER',
  INVITE_USER_SUCCESS = 'USER_MANAGEMENT/INVITE_USER_SUCCESS',
  INVITE_USER_ERROR = 'USER_MANAGEMENT/INVITE_USER_ERROR',
  RESTORE_MERCHANT_USER = 'USER_MANAGEMENT/RESTORE_MERCHANT_USER',
  RESTORE_MERCHANT_USER_SUCCESS = 'USER_MANAGEMENT/RESTORE_MERCHANT_USER_SUCCESS',
  RESTORE_MERCHANT_USER_ERROR = 'USER_MANAGEMENT/RESTORE_MERCHANT_USER_ERROR',
  RESEND_INVITE = 'USER_MANAGEMENT/RESEND_INVITE',
  RESEND_INVITE_SUCCESS = 'USER_MANAGEMENT/RESEND_INVITE_SUCCESS',
  RESEND_INVITE_ERROR = 'USER_MANAGEMENT/RESEND_INVITE_ERROR',
}

export const getMerchantUsers = (page?: number, pageSize?: number, filters?: { email?: string; name?: string }) => ({
  type: UserManagementActionType.GET_MERCHANT_USERS,
  page,
  pageSize,
  filters,
});

export const getMerchantUsersSuccess = (response: MerchantUsersResponse) => ({
  type: UserManagementActionType.GET_MERCHANT_USERS_SUCCESS,
  response,
});

export const getMerchantUsersError = (error: ErrorAPI) => ({
  type: UserManagementActionType.GET_MERCHANT_USERS_ERROR,
  error,
});

export const deleteMerchantUser = (merchantUserId: number) => ({
  type: UserManagementActionType.DELETE_MERCHANT_USER,
  merchantUserId,
});

export const deleteMerchantUserSuccess = () => ({
  type: UserManagementActionType.DELETE_MERCHANT_USER_SUCCESS,
});

export const deleteMerchantUserError = (error: ErrorAPI) => ({
  type: UserManagementActionType.DELETE_MERCHANT_USER_ERROR,
  error,
});

export const cleanError = () => ({
  type: UserManagementActionType.CLEAN_ERROR,
});

export const updateUserRole = (userId: number, role: string) => ({
  type: UserManagementActionType.UPDATE_USER_ROLE,
  userId,
  role,
});

export const swapOwnerRole = (merchantUserId: number) => ({
  type: UserManagementActionType.SWAP_OWNER_ROLE,
  merchantUserId,
});

export const swapOwnerRoleSuccess = () => ({
  type: UserManagementActionType.SWAP_OWNER_ROLE_SUCCESS,
});

export const swapOwnerRoleError = (error: ErrorAPI) => ({
  type: UserManagementActionType.SWAP_OWNER_ROLE_ERROR,
  error,
});

export const inviteUser = ({ fullName, email, role }: InviteUserRequest) => ({
  type: UserManagementActionType.INVITE_USER,
  fullName,
  email,
  role,
});

export const inviteUserSuccess = () => ({
  type: UserManagementActionType.INVITE_USER_SUCCESS,
});

export const inviteUserError = (error: ErrorAPI) => ({
  type: UserManagementActionType.INVITE_USER_ERROR,
  error,
});

export const restoreMerchantUser = (merchantUserId: number) => ({
  type: UserManagementActionType.RESTORE_MERCHANT_USER,
  merchantUserId,
});

export const restoreMerchantUserSuccess = () => ({
  type: UserManagementActionType.RESTORE_MERCHANT_USER_SUCCESS,
});

export const restoreMerchantUserError = (error: ErrorAPI) => ({
  type: UserManagementActionType.RESTORE_MERCHANT_USER_ERROR,
  error,
});

export const resendInvite = (merchantUserId: number) => ({
  type: UserManagementActionType.RESEND_INVITE,
  merchantUserId,
});

export const resendInviteSuccess = () => ({
  type: UserManagementActionType.RESEND_INVITE_SUCCESS,
});

export const resendInviteError = (error: ErrorAPI) => ({
  type: UserManagementActionType.RESEND_INVITE_ERROR,
  error,
});
